import type { GuidedV2Emitters } from '../../models/eventNames';
import { h } from '@stencil/core';
import { splitByDelimiters } from '../../utils';

export type NoResultsMessageProps = {
    message: string;
    searchTerm: string;
    clickTarget?: string;
    eventEmitters: GuidedV2Emitters;
    subTitle: string;
};

//renderMessage function could be used in future for more advanced feature
export const renderMessage = (message: string, linkTarget: string, searchTerm: string) => {
    const parts = splitByDelimiters(message, ['$TERM', '**']);
    let insideBold = false;

    return parts.map((part, index) => {
        if (part === '$TERM') {
          return <span key={index} class="guided-v2-no-links-message__highlight">{searchTerm}</span>;
        }
        if (part === '**') {
          insideBold = !insideBold;
          return null;
        }
        if (insideBold) {
          return (
            <a key={index} href={linkTarget.replace('$TERM', encodeURIComponent(searchTerm))}
              class="guided-v2-no-links-message__link">
              {part}
            </a>
          );
        }
        return <span key={index} class="regular-text">{part}</span>;
    });
};

export const NoResultMessage = (params: NoResultsMessageProps) => {
    const { message, searchTerm, eventEmitters, subTitle } = params;

    const emitters = eventEmitters ? eventEmitters() : undefined;
    const emitter = emitters
      ? () => emitters.bannerClicked.emit({ term: searchTerm })
        : () => console.log('NoLinksMessage emitter is undefined'); // eslint-disable-line


    return (
      <div class="guided-v2-no-links-message__message" onClick={emitter}>
        <div class="guided-v2-no-results-message__icon_centered">
          <qds-icon name="folder-magnifying-glass" library="default"/>
        </div>
        <qds-title layer="panel" level="subsection" alignment="center" subtitle={subTitle}>{message}</qds-title>
      </div>
    );
};
